<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nHqZep/tc-custom/9798368860749.jpg?1742008693616" alt="This image is the cover for the book The Power Fantasy #5, The Power Fantasy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Power Fantasy #5, The Power Fantasy
      </h1>
      <p class="bookDescription body article font2">
        <p>END OF STORY ARC They call aging punk Jacky Magus a sellout, just because he's betrayed his principles. Jacky Magus rolls his eyes. Oh, you sweet naive things. He hasn't even begun to sell out yet. As the first arc of THE POWER FANTASY ends, we discover exactly what the world's worth.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kieron Gillen, Caspar Wijngaard
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?025143f0